import { createFileRoute } from '@tanstack/react-router'

import { ConfigPage, type ConfigTab } from '@/features/config/config-page'

type ConfigSearch = {
  tab?: ConfigTab
}

const TABS: ConfigTab[] = ['perfil', 'seguranca', 'notificacoes', 'calendario']

export const Route = createFileRoute('/_app/config')({
  validateSearch: (search: Record<string, unknown>): ConfigSearch => ({
    tab: TABS.includes(search.tab as ConfigTab)
      ? (search.tab as ConfigTab)
      : 'perfil',
  }),
  component: ConfigRoute,
})

function ConfigRoute() {
  const navigate = Route.useNavigate()
  const { tab = 'perfil' } = Route.useSearch()

  return (
    <ConfigPage
      tab={tab}
      onTabChange={(nextTab) =>
        void navigate({ search: (prev) => ({ ...prev, tab: nextTab }) })
      }
    />
  )
}
